const BASE_ENDPOINT = process.env.REACT_APP_API_BASE_URL;

export const ENDPOINT_DEV = `${BASE_ENDPOINT}/api/v1/`;
/* export const ORG_ID = process.env.REACT_APP_ORG_ID ? process.env.REACT_APP_ORG_ID : "sharedstudios_dev" */
